import gql from 'graphql-tag'

const deleteThread = gql`
  mutation ($thread_id: Float!) {
    deleteThread(thread_id: $thread_id) {
      status
      msg
      data
    }
  }
`

export default deleteThread
